module.exports = __webpack_public_path__ + "assets/img/23ad-pt.svg";